export const bookingHasPlaceholderTickets = ({ booking = {} }) =>
  [...(booking.outbound || []), ...(booking.inbound || [])]
    .filter(({ cancelled = false }) => !cancelled)
    .some(({ products = [] }) => products.filter(({ cancelled = false }) => !cancelled)?.some(({ isPlaceholder }) => isPlaceholder));
